import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Stack,
  Text,
} from '@billda/design-system';

interface ConfirmAddPlotDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  plotName?: string;
  plotNumber?: string;
  siteName?: string;
}

/**
 * Confirmation dialog for adding a plot
 * Molecule component following Atomic Design Structure
 */
export function ConfirmAddPlotDialog({
  open,
  onClose,
  onConfirm,
  plotName,
  plotNumber,
  siteName,
}: ConfirmAddPlotDialogProps) {
  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent className="max-w-sm sm:max-w-md">
        <DialogHeader>Confirm Add Plot</DialogHeader>
        <DialogBody>
          <Text variant="body1" className="mb-2">
            Are you sure you want to create this plot?
          </Text>
          <div className="mt-4 rounded-lg bg-surface-raised p-4">
            <Stack spacing={1}>
              <div>
                <Text variant="caption" color="secondary">
                  Plot Name
                </Text>
                <Text variant="body2" className="font-medium">
                  {plotName}
                </Text>
              </div>
              <div>
                <Text variant="caption" color="secondary">
                  Plot Number
                </Text>
                <Text variant="body2" className="font-medium">
                  {plotNumber}
                </Text>
              </div>
              <div>
                <Text variant="caption" color="secondary">
                  Site
                </Text>
                <Text variant="body2" className="font-medium">
                  {siteName}
                </Text>
              </div>
            </Stack>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="neutral" onClick={onConfirm} autoFocus>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
